var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDecor(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 608,
    height: 228,
    viewBox: "0 0 608 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.08,
    cx: 134,
    cy: 58,
    r: 14,
    stroke: "#222222",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.08,
    cx: 592,
    cy: 212,
    r: 14,
    stroke: "#222222",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.12,
    cx: 26.5,
    cy: 59.5,
    r: 15.5,
    stroke: "#222222",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.12,
    cx: 503.5,
    cy: 195.5,
    r: 15.5,
    stroke: "#222222",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.08,
    cx: 26.5,
    cy: 189.5,
    r: 24.5,
    stroke: "#222222",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.08,
    cx: 550.5,
    cy: 151.5,
    r: 24.5,
    stroke: "#222222",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 108,
    cy: 163,
    r: 27,
    stroke: "#222222",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 563,
    cy: 29,
    r: 27,
    stroke: "#222222",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.16,
    cx: 73,
    cy: 105,
    r: 9,
    stroke: "#222222",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.16,
    cx: 523,
    cy: 93,
    r: 9,
    stroke: "#222222",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecor);
export default __webpack_public_path__ + "static/media/decor.0a8785d9ecce0619bbb3352f5482f4ae.svg";
export { ForwardRef as ReactComponent };